import { CommonModule } from '@angular/common';
import { Component, inject, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { PagesService } from '@services/pages.service';
import { SharedService } from '@services/shared.service';
import { SafeHtmlPipe } from 'src/app/pipes/safe-html.pipe';

@Component({
  selector: 'app-terms-condition',
  imports: [CommonModule, SafeHtmlPipe],
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.scss'],


})
export class TermsConditionComponent {
  isOuterRoute = false;
  conditions: any;
  pageService = inject(PagesService)
  sharedService = inject(SharedService);
  SafeHtmlPipe!: SafeHtmlPipe;

  constructor(private router: Router) { }

  ngOnInit(): void {
    const hash = window.location.hash;
    const path = hash.replace(/^#/, '');
    this.isOuterRoute = path === '/terms-conditions';
    this.loadTermsCondition();

  }


  loadTermsCondition() {
    this.sharedService.showLoader();

    this.pageService.getAll('GET_TERMS_CONDITION').subscribe({
      next: (res: any) => {
        if (res && res.length > 0) {
          this.conditions = res[0];
        }
      },
      error: (err: any) => {
        console.error('Failed to load privacy policy', err);
        // Agar error aaye to bhi loader hide kar do
        this.sharedService.hideLoader();
      },
      complete: () => {
        // Request complete hone par loader hide kar do
        this.sharedService.hideLoader();
      }
    });
  }
}
